import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ authenticated, adminOnly=false, user, children }) {
    if (!authenticated) return <Navigate to="/login" />;
    else if ( authenticated && adminOnly) {
      if (user.role==='admin') {
        return children
      }
      else {
        return <Navigate to="/wyceny" />
      }
    }
    else if (authenticated && !adminOnly) {
      return children
    }
  }

export default ProtectedRoute